module.exports = __webpack_public_path__ + "static/media/5.6.2b1f0911.png";